import alt from "../alt";
import GlobalNotificationActions from "../actions/GlobalNotificationActions";

class GlobalNotificationStore {
  constructor() {
    this.bindActions(GlobalNotificationActions);

    this.state = {
      open: false,
      message: "",
      action: {}
    };
  }

  onNotify(message) {
    let action;

    if (typeof message === "object") {
      action = message.action || {};
      message = message.message;
    }

    this.setState({ open: true, message: message, action: action });
  }

  onClose() {
    this.setState({ open: false });
  }
}

export default alt.createStore(
  GlobalNotificationStore,
  "GlobalNotificationStore"
);



// WEBPACK FOOTER //
// ./src/app/stores/GlobalNotificationStore.js